import React from "react";
import type { FC } from "react";

const Welcome: FC = () => {
  return <>% username %，欢迎您！</>;
};

export { Welcome };
